import {
  post,
  get,
  content_types,
  convertToForm,
  deletee,
  put
} from 'services';
import { AxiosPromise } from 'axios';
import { IPart, sortBy } from 'types/index';
import { getAuth } from './localStorage';

export type IgetPartParams = {
  offset?: number;
  search?: string;
  limit: number;
  submodel?: string;
  sortBy?: sortBy;
  sortField?: string;
};
export type IGetPartRes = {
  total: number;
  parts: IPart[];
};
export const getPartsService = (
  params: IgetPartParams
): AxiosPromise<IGetPartRes> => {
  const user = getAuth().user;
  if (!user) {
    return Promise.reject();
  }
  return get({
    subUrl: '/pattern/list',
    params: { ...params, user_id: user.id }
  });
};
export type IAddPartData = {
  patternType: string;
  name: string;
  brand: string;
  region: string;
  model: string;
  submodel: string;
  makingYear: any;
  startMakingYear: string;
  endmakingYear: string;
  autoIncrementEndYear?: boolean;
  file: Blob;
  model_image?: Blob;
  over_write?: boolean;
};
export const addPartService = (data: IAddPartData | any): AxiosPromise<any> => {
  const user = getAuth().user;
  if (!user) {
    return Promise.reject();
  }

  delete data.makingYear;
  console.log(data);
  const formdata = convertToForm({ ...data, user_id: user.id });
  return post({
    subUrl: '/pattern/create',
    data: formdata,
    headers: {
      ...content_types.multipart
    }
  });
};

export type editPartData = Partial<IAddPartData> & { id: string };

export const editPartService = (data: editPartData): AxiosPromise<any> => {
  const user = getAuth().user;
  if (!user) {
    return Promise.reject();
  }
  const formdata = convertToForm({ ...data, user_id: user.id });

  return post({
    subUrl: '/pattern/update',
    data: formdata,
    headers: {
      ...content_types.multipart
    }
  });
};
export type deletePartData = {
  id: string;
};
export const deletePartService = (data: deletePartData): AxiosPromise<any> => {
  return deletee({
    subUrl: '/pattern/delete-part',
    params: data
  });
};
export type subModelData = {
  [key: string]: string | File;
  part_id: string;
};

export type trimData = {
  [key: string]: string | File;
  submodel_id: string;
};

export const createSubModelService = (
  data: subModelData | any
): AxiosPromise<any> => {
  const formData = convertToForm(data);
  return post({
    subUrl: '/pattern/create-submodel',
    data: formData,
    headers: {
      ...content_types.multipart
    }
  });
};

export const updateSubModelService = (
  data: subModelData | any
): AxiosPromise<any> => {
  const formData = convertToForm(data);
  return post({
    subUrl: '/pattern/update-submodel',
    data: formData,
    headers: {
      ...content_types.multipart
    }
  });
};
export type deleteSubModelData = {
  part_id: string;
  id: string;
};
export const deleteSubModelSerice = (data: deleteSubModelData) => {
  return deletee({
    subUrl: '/pattern/delete-submodel',
    params: data
  });
};

export type getPartData = {
  id: string;
};
export type IgetPartByIdReturnData = {
  partData: IPart;
};
export const getPartByIdService = (
  data: getPartData
): AxiosPromise<IgetPartByIdReturnData> => {
  return get({
    subUrl: '/pattern/profile',
    params: data
  });
};

export const createTrimService = (
  data: subModelData | any
): AxiosPromise<any> => {
  const formData = convertToForm(data);
  return post({
    subUrl: '/pattern/trims',
    data: formData,
    headers: {
      ...content_types.multipart
    }
  });
};

export const updateTrimService = (
  data: subModelData | any
): AxiosPromise<any> => {
  const formData = convertToForm(data);
  return put({
    subUrl: '/pattern/trims',
    data: formData,
    headers: {
      ...content_types.multipart
    }
  });
};
export const deleteTrimService = (id: string) => {
  return deletee({
    subUrl: '/pattern/trims',
    params: { id }
  });
};

export const orderTrimService = (data: {
  id: string;
  index: number;
  type: string;
}) => {
  return post({
    subUrl: '/pattern/adjust-order',
    data
  });
};

export const getVersionService = (part_id: string) => {
  return get({
    subUrl: '/pattern/version',
    params: { part_id }
  });
};

export const setVersionService = (data: { id: string; part_id: string }) => {
  return post({
    subUrl: '/pattern/version',
    data
  });
};

export const toggleIsVerifiedOrIsEdgeWrapped = (data: {
  bool: boolean;
  key: string;
  id: string;
}): AxiosPromise<any> => {
  return post({
    subUrl: '/pattern/toggle',
    data: data
  });
};
